module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_9.a9130ef8.jpg";